import {PopperInstance, RefElement} from 'cytoscape-popper';
import tippy, {roundArrow} from 'tippy.js';
import 'tippy.js/dist/svg-arrow.css';
import {graphElementId} from './use-cytoscape-initialization';
import {CollectionReturnValue} from 'cytoscape';
import popoverStyle from '../components/graph.module.css';

export function tippyFactory(ref: RefElement, content: HTMLElement) {
    const dummyDomEle = document.createElement('div');

    return tippy(dummyDomEle, {
        getReferenceClientRect: ref.getBoundingClientRect,
        trigger: 'manual',
        content: content,
        arrow: roundArrow,
        placement: 'top',
        hideOnClick: false,
        sticky: 'reference',
        appendTo: document.getElementById(graphElementId) as HTMLDivElement
    });
}

const popperInstancesMap: {[id: number]: PopperInstance} = {};

export function createPopoverForElement(
    el: CollectionReturnValue,
    nodeId: number,
    containerElement: HTMLDivElement | null
) {
    const tip = el.popper({
        content: () => {
            const div = document.createElement('div');

            div.innerHTML = el.data().label;
            div.className = popoverStyle.popover;

            containerElement!.appendChild(div);

            return div;
        }
    });

    tip.show();
    popperInstancesMap[nodeId] = tip;
}

export function destroyPopoverForElement(nodeId: number) {
    if (popperInstancesMap[nodeId]) {
        popperInstancesMap[nodeId].destroy();
        delete popperInstancesMap[nodeId];
    }
}
